import { render, staticRenderFns } from "./ProductTile.vue?vue&type=template&id=34f393da&"
import script from "./ProductTile.vue?vue&type=script&lang=ts&"
export * from "./ProductTile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports